import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveProcedureCatalog() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((procedureId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = procedureId
      ? quarkusApi.put(`/procedures-catalog/${procedureId}`, payload, authHeader)
      : quarkusApi.post('/procedures-catalog', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
